// Shared block-alignment for the media nodes (image, video). Stored as
// data-align on the serialized element (default 'left' is omitted); the editor
// NodeViews map it to a flex justify class. The public site (Phase 2) styles
// data-align too.
export type MediaAlign = 'left' | 'center' | 'right'

export const alignAttribute = {
  align: {
    default: 'left' as MediaAlign,
    parseHTML: (element: HTMLElement) => (element.getAttribute('data-align') as MediaAlign) || 'left',
    renderHTML: (attributes: { align?: MediaAlign }) =>
      attributes.align && attributes.align !== 'left' ? { 'data-align': attributes.align } : {},
  },
}

export function alignJustifyClass(align: MediaAlign | undefined): string {
  if (align === 'center') return 'justify-center'
  if (align === 'right') return 'justify-end'
  return 'justify-start'
}
